import api from './api';

const authContextFor = (audience) => (audience === 'customer' ? 'customer' : 'management');

export const getPushPublicKey = async (audience) => {
  const response = await api.get('/push-subscriptions/public-key', {
    _authContext: authContextFor(audience),
    _omitStoreId: true,
  });
  return response.data?.publicKey || '';
};

export const registerPushSubscription = async (audience, subscription) => {
  await api.put('/push-subscriptions', subscription, {
    _authContext: authContextFor(audience),
    _omitStoreId: true,
  });
};

export const deletePushSubscription = async (audience, endpoint) => {
  await api.delete('/push-subscriptions', {
    data: { endpoint },
    _authContext: authContextFor(audience),
    _omitStoreId: true,
  });
};
